"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var fetch_1 = require("../utils/fetch");
var transform_1 = require("../utils/transform");
var getProfile = function () {
    return fetch_1.default("/me/profile", {
        method: "GET",
    });
};
var removeProfile = function () {
    return fetch_1.default("/me", { method: "DELETE" });
};
var changePassword = function (oldPassword, newPassword) {
    return fetch_1.default("/me/password", {
        method: "PATCH",
        body: JSON.stringify({
            old_password: oldPassword,
            new_password: newPassword,
        }),
    });
};
var getPublicUserProfile = function (id) {
    return fetch_1.default("/users/" + id, {
        method: "GET",
    });
};
var updateProfile = function (userInput) {
    var body = transform_1.toSnakeCase(userInput);
    return fetch_1.default("/me/profile", {
        method: "PATCH",
        body: JSON.stringify(body),
    });
};
var updateImage = function (image, imageType, contentType) {
    if (contentType === void 0) { contentType = "multipart/form-data"; }
    return fetch_1.default("/me/images/" + imageType, {
        method: "PUT",
        body: image,
    }, {}, contentType);
};
var serializeArea = function (data) { return (__assign(__assign({}, data), (data.place
    ? {
        place: {
            address: data.place.address,
            latitude: Number.parseFloat(data.place.latitude.toFixed(8)),
            longitude: Number.parseFloat(data.place.longitude.toFixed(8)),
        },
    }
    : {}))); };
var addArea = function (data) {
    var body = JSON.stringify(serializeArea(data));
    return fetch_1.default("/me/areas", {
        method: "POST",
        body: body,
    });
};
var updateArea = function (id, data) {
    var body = JSON.stringify(serializeArea(data));
    return fetch_1.default("/me/areas/" + id, {
        method: "PATCH",
        body: body,
    });
};
var removeArea = function (id) {
    return fetch_1.default("/me/areas/" + id, {
        method: "DELETE",
    });
};
var getAreas = function () {
    return fetch_1.default("/me/areas", {
        method: "GET",
    });
};
var getAccountInfo = function () {
    return fetch_1.default("/me/account", {
        method: "GET",
    });
};
var updateFcmToken = function (token) {
    var body = JSON.stringify({ token: token });
    return fetch_1.default("/fcm/token", {
        method: "PATCH",
        body: body,
    });
};
var getAllUsers = function (params) {
    return fetch_1.default("/users", { method: "GET" }, params
        ? __assign({ roles: params.roles ? params.roles.join(",") : undefined, search: params.search }, _.pick(params, ["until", "since", "limit", "orderBy"])) : undefined);
};
var block = function (id) {
    return fetch_1.default("/users/" + id + "/block", { method: "POST" });
};
var remove = function (id) {
    return fetch_1.default("/users/" + id, { method: "DELETE" });
};
exports.default = {
    getProfile: getProfile,
    changePassword: changePassword,
    getPublicUserProfile: getPublicUserProfile,
    updateProfile: updateProfile,
    updateImage: updateImage,
    addArea: addArea,
    updateArea: updateArea,
    removeArea: removeArea,
    getAreas: getAreas,
    getAccountInfo: getAccountInfo,
    updateFcmToken: updateFcmToken,
    getAllUsers: getAllUsers,
    block: block,
    removeProfile: removeProfile,
    remove: remove,
};
//# sourceMappingURL=users.js.map